import {
  Body1Stronger,
  Card,
  SkeletonItem,
  Text,
} from '@fluentui/react-components';
import React from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { Flex } from '@tdp/common/fluentV9MigrationComponents';
import { useSelector } from '@tdp/core';

import { useOverviewCardStyles } from './AppValidationDetails.styles';
import { appDetailsSlice } from '../../appDetails/slice';

export const BasicInfo: React.FC = () => {
  const intl = useIntl();
  const classes = useOverviewCardStyles();

  const { appId } = useParams();
  const app = useSelector((s) =>
    appDetailsSlice.selectors.getAppById(s, appId ?? '')
  );

  if (!app) {
    return <OverviewBasicInfoShimmer />;
  }

  return (
    <Card className={classes.card}>
      <header>
        <Body1Stronger>
          {intl.formatMessage({
            defaultMessage: 'Basic information',
            description:
              'Card title for the basic information card on the overview page.',
          })}
        </Body1Stronger>
      </header>
      <Flex column gap="gap.medium" className={classes.flex}>
        <Flex column>
          <Text size={500}>{app.shortName}</Text>
          <Text>
            {intl.formatMessage({
              defaultMessage: 'Name',
              description: 'shortName',
            })}
          </Text>
        </Flex>
        <Flex column>
          <Text size={500}>{app.version}</Text>
          <Text>
            {intl.formatMessage({
              defaultMessage: 'Version',
              description: 'version',
            })}
          </Text>
        </Flex>
        <Flex column>
          <Text size={500}>{app.appId}</Text>
          <Text>
            {intl.formatMessage({
              defaultMessage: 'App ID',
              description: 'Basic Information page, App ID section text',
            })}
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};

const OverviewBasicInfoShimmer: React.FC = () => {
  const classes = useOverviewCardStyles();
  return (
    <Card className={classes.card}>
      <Flex fill gap="gap.large" column>
        <SkeletonItem style={{ width: '30%' }}></SkeletonItem>
        <Flex gap="gap.medium" column>
          <SkeletonItem style={{ width: '100%' }}></SkeletonItem>
          <SkeletonItem style={{ width: '80%' }}></SkeletonItem>
        </Flex>
        <Flex gap="gap.medium" column>
          <SkeletonItem style={{ width: '100%' }}></SkeletonItem>
          <SkeletonItem style={{ width: '80%' }}></SkeletonItem>
        </Flex>
        <Flex gap="gap.medium" column>
          <SkeletonItem style={{ width: '30%' }}></SkeletonItem>
        </Flex>
      </Flex>
    </Card>
  );
};
